import { connect } from 'react-redux'
import * as action from '../../../state/overview/info-table/action'
import * as selector from '../../../state/overview/info-table/selector'
import FoilInfoTable from './FoilInfoTable'


const mapStateToProps = state => {
    return {
        ...selector.selectOwnState(state),
        tableSetting: selector.selectTableSetting(state),
    }
}

const mapDispatchToProps = {
    getFoilList: action.getFoilList,
    changeTableSetting: action.changeTableSetting,
}


export default connect(mapStateToProps, mapDispatchToProps)(FoilInfoTable)



// WEBPACK FOOTER //
// ./src/modules/foil/component/overview/info-table/FoilInfoTableContainer.js